import HyperDX from '@hyperdx/browser'

import { isNotEmpty } from './lodash'

if (isNotEmpty(import.meta.env.VITE_HYPERDX_API_KEY)) {
  HyperDX.init({
    apiKey: import.meta.env.VITE_HYPERDX_API_KEY,
    service: `charger-frontend-${import.meta.env.VITE_ENVIRONMENT}`,
    consoleCapture: true,
    advancedNetworkCapture: true
  })
}
